
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TestimonialsSection: React.FC = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: '张总',
      company: '某教育科技公司',
      position: 'CEO',
      content: '合作非常愉快！团队技术实力强，项目按时交付，质量超出预期。特别是在用户体验设计方面，给了我们很多专业建议。',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20executive%20portrait%2C%20confident%20CEO%20in%20modern%20office%2C%20business%20suit%2C%20professional%20headshot%2C%20clean%20background%2C%20corporate%20leadership%20style&width=100&height=100&seq=avatar-ceo-001&orientation=squarish'
    },
    {
      id: 2,
      name: '李经理',
      company: '某零售连锁企业',
      position: '技术总监',
      content: '小程序开发项目非常成功，用户活跃度提升了200%。团队对业务理解深入，提供的解决方案很有针对性。',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20technology%20director%20portrait%2C%20experienced%20IT%20manager%2C%20business%20attire%2C%20confident%20expression%2C%20modern%20office%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-tech-001&orientation=squarish'
    },
    {
      id: 3,
      name: '王总',
      company: '某制造业集团',
      position: 'CTO',
      content: 'PHP到Go的迁移项目执行得很专业，系统性能提升明显，维护成本也大幅降低。技术团队经验丰富，值得信赖。',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20CTO%20portrait%2C%20senior%20technology%20executive%2C%20business%20suit%2C%20experienced%20leader%2C%20modern%20corporate%20environment%2C%20professional%20headshot&width=100&height=100&seq=avatar-cto-001&orientation=squarish'
    },
    {
      id: 4,
      name: '陈总',
      company: '某金融科技公司',
      position: '产品总监',
      content: 'APP开发质量很高，用户反馈非常好。团队沟通顺畅，能够快速响应需求变更，是很好的合作伙伴。',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20product%20director%20portrait%2C%20fintech%20executive%2C%20modern%20business%20attire%2C%20confident%20professional%2C%20clean%20office%20background%2C%20corporate%20headshot&width=100&height=100&seq=avatar-product-001&orientation=squarish'
    },
    {
      id: 5,
      name: '刘总',
      company: '某医疗机构',
      position: '信息主管',
      content: '预约平台上线后，患者满意度显著提升，医院运营效率也得到了很大改善。技术支持及时，服务态度很好。',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20healthcare%20IT%20manager%20portrait%2C%20medical%20industry%20executive%2C%20professional%20attire%2C%20trustworthy%20appearance%2C%20hospital%20or%20medical%20office%20background&width=100&height=100&seq=avatar-medical-001&orientation=squarish'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1);
  };

  const prevSlide = () => {
    setCurrentIndex(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1);
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('testimonials.intro')}
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {/* Main Testimonial */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-20 h-20 bg-blue-600/10 rounded-full -translate-x-10 -translate-y-10"></div>
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-blue-600/5 rounded-full translate-x-16 translate-y-16"></div>
            
            <div className="relative z-10">
              {/* Quote Icon */}
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-double-quotes-l text-white text-xl"></i>
              </div>

              {/* Rating */}
              <div className="flex justify-center mb-6">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400"></i>
                  </div>
                ))}
              </div>

              {/* Content */}
              <blockquote className="text-xl md:text-2xl text-gray-700 text-center mb-8 leading-relaxed">
                "{testimonials[currentIndex].content}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center justify-center">
                <img 
                  src={testimonials[currentIndex].avatar}
                  alt={testimonials[currentIndex].name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div className="text-left">
                  <h4 className="text-lg font-bold text-gray-900">
                    {testimonials[currentIndex].name}
                  </h4>
                  <p className="text-blue-600 font-medium">
                    {testimonials[currentIndex].position}
                  </p>
                  <p className="text-gray-600 text-sm">
                    {testimonials[currentIndex].company}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer"
          >
            <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer"
          >
            <i className="ri-arrow-right-line text-gray-600 text-xl"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex 
                    ? 'bg-blue-600 w-8' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          {[
            { number: '100+', label: t('stats.projects') },
            { number: '50+', label: t('stats.clients') },
            { number: '99%', label: t('stats.satisfaction') },
            { number: '24/7', label: t('stats.support') }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
